import React, { useState } from "react";
import StatedTrackable from "../components/StatedList";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import BarChart from "../components/widgets/BarChart";
import TableDataWithTabs from "../components/widgets/TableDataWithTabs";
import StateList from "../components/StateList";

export default function Inventory() {
  //const trackableRef = useRef();
  const [seeDetail, setSeeDetail] = useState(false);
  const clickDetail = (e) => {
    e.preventDefault();
    setSeeDetail(true);
  };
  return (
    <div>
      <Container fixed>
        {!seeDetail ? (
          <>
            <StatedTrackable dataType="assets" />
            <br />
            <div>
              <Button variant={"text"} onClick={clickDetail}>
                See Detail
              </Button>
            </div>
          </>
        ) : (
          ""
        )}
        {seeDetail ? (
          <>
            <div>
              <h2>States</h2>
              <StateList />
            </div>
            <h2>Event Timeline</h2>
            <BarChart />
            <TableDataWithTabs />
          </>
        ) : (
          ""
        )}
      </Container>
    </div>
  );
}
